require('./loadingWithOpacity.scss');

const PropTypes = require('prop-types');
const React = require('react');

// @commons
const { LoadingSection } = require('commonsComponents/loadingSection');

class LoadingWithOpacity extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        const { visible, contextClass, extraClassOpacity } = this.props;

        if(visible) {
            return (
                <div>
                    <div className={`loading-with-opacity__section ${contextClass}`} style={{top: this.props.top}}>
                        <LoadingSection />
                    </div>
                    <div id="loading-with-opacity" className={`loading-with-opacity ${extraClassOpacity}`}></div>
                </div>
            );
        }

        return null;
    }
}

LoadingWithOpacity.propTypes = {
    top: PropTypes.number,
    visible: PropTypes.bool.isRequired,
    contextClass: PropTypes.string,
    extraClassOpacity: PropTypes.string
};

LoadingWithOpacity.defaultProps = {
    top: 0,
    extraClassOpacity: ""
}

module.exports = LoadingWithOpacity;